<template>
    <div class="d-flex p-0 mr-0 mt-4 g-3 align-items-center address" :class="{'mt-0': this.first, 'flex-column': labelTop}">
        <div class="d-flex align-items-center mb8" :class="{ 'col-6': !labelTop, 'col-12': labelTop }">
            <label :for="id" class="mt-0 pl-0 pt-0 pb-0" :class="{ 'primary-grey': !labelTop, 'fsp14 lh20': labelTop }">
                {{this.label}}
                <span class='require' v-if="this.require"> *</span>
            </label>
            <Popper v-if="this.hint" :hover="true" :id="id + '_hint'">
                <Icon name="info" size="c16" class="ml4" />
                <template #content>
                    <span>{{ this.hint }}</span>
                </template>
            </Popper>
        </div>
        <div class="mt-0 p-0 address-wrapper d-flex align-items-center gap-2" :class="{ 'col-6': !labelTop, 'col-12': labelTop, 'm-0': labelTop }">
            <!-- <InputSimple :id="id" :invalid='this.invalid' :invalidHint='this.invalidHint' :autocomplete="this.autocomplete" :type=type :disabled='this.disabled' @blurInput="this.blure" :regCheck='this.regCheck' :dataValue='this.dataValue' @updateParentState="this.setValue"/> -->
            <div
				class='form-control gr-address border-full'
                :class="{'disabled': this.disabled, 'pointer': !this.disabled}"
                :id="id + '_select'"
                v-on:click="this.showParams"
				data-trigger="hover"  data-placement="auto right" data-container="body" data-html="true"
			>
                {{ this.dField.value_text }}
            </div>
            <!-- <div v-else-if="this.unvisible" class="mw34"></div> -->
            <Popper
                v-if="this.verification"
                :id="id + '_check'"
                :hover="true"
            >
                <Icon name="check-mark" :color="{ 0: '#018A5A'}" class="c18" />
                <template #content>
                    <span>{{ $t('views.InfoReg.3') }}</span>
                </template>
            </Popper>
            <!-- <div v-else-if="this.unvisible || this.vMark" class="mw34"></div> -->
            <Popper v-if="this.unvisible" :hover="true" :id="id + '_va'">
                <SwitchSimple
                    :id="id + '_switch_id'"
                    :dataValue='this.unvisibleValue'
                    :disabled="this.is_public == '2' ? true : false"
                    :type="'sm'"
                    @updateParentState="this.setUnvisibleValue"
                />
                <template #content>
                    <span>{{ $t('views.InfoReg.4') }}</span>
                </template>
            </Popper>
        </div>
    </div>
</template> 

<script>
import SwitchSimple from '@/components/service/SwitchSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';
import Popper from '@/components/service/Popper';

export default {
    components: {
        Tooltip,
        SwitchSimple,
        Icon,
        Popper
    },
    data() {
        return {
            addr_v: this.addr ? this.addr : {},
            dField: this.field ? this.field : {},
            sizeW: this.$store.state.resize.w,
            unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : '',
        }
    },
    props: {
        first: {
            type: Boolean,
            default: false,
        },
        id: [String, Boolean],
        label: [String],
        hint: [String, Boolean],
        addr: [Object, Boolean], 
        field: [Object, Boolean], 
        require: [Boolean],
        disabled: [String, Boolean],
        invalid: [Boolean],
        invalidHint: [String, Boolean],
        unvisible: [Boolean],
        unvisibleDataValue: [String, Boolean], 
        vMark: [Boolean],
        is_public: [Boolean, String],
        verification: [Boolean],
        getAddress: [String],
        labelTop: [Boolean],
    },
    methods: {
        findAddressValue(data) {
            // Проверяем: data массив или объект
            if (Array.isArray(data)) {
                for (const item of data) {
                    const result = this.findAddressValue(item);
                    if (result) {
                        return result;
                    }
                }
            } else if (typeof data === 'object' && data !== null) {
                // Если это объект, проверяем его ключи
                if (data.key === 'address') {
                    return data.value;
                }
                // Рекурсивно проверяем все значения объекта
                for (const key in data) {
                    const result = this.findAddressValue(data[key]);
                    if (result) {
                        return result;
                    }
                }
            }
            return null;
        },
        getlistAddress(valText) {
            if (valText || !this.dField?.value) {
                return;
            }

            this.axios.post('getlistAddress', {data: {house: this.dField.value}}).then(res => {
                if (res.data.body.result == '0') {
                    const address = this.findAddressValue(res.data.body.tables);
                    this.dField.value_text = address;
                }
            })
        },
        setValue(arg) {
            // console.log('setValue address not modal', arg);
            this.$emit('updateParentState', {
                id: arg.id,
                value: arg.value
            })
        },
        setTextValue(arg) {
            this.$emit('updateParentTextState', {
                id: arg.id,
                value: arg.value
            })
        },
        setUnvisibleValue(arg) {
            this.$emit('updateParentState', { 
                id: arg.id.replace(/_switch_id/, ''),
                unvisible: true,
                value: arg.value
            })
        },
        showParams() {
            // console.log('showParams, addr_v', this.addr_v);
            this.$store.commit('MODAL', {
                    action: true,
                    type: 'address',
                    content: {
                        field: this.dField,
                        addr: this.addr_v,
                        updateState: (arg, text) => {
                            // console.log('updateState');
                            this.setValue(arg);
                            this.dField.value_text = text;

                            if (arg.new_addr) {
                                this.addr_v = arg.new_addr;
                            }
                        },
                    },
                    }
            );
        },
    },
    created() {
        console.log('created not modal addr', this.addr);
        console.log('created not modal dField', this.dField);
        this.getlistAddress(this.dField.value_text);
    }

}
</script>

<style lang="scss" scoped>
.address {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
    .gr-address {
        resize: none;
        display: inline-block;
        height: auto;
        min-height: 34px;
    }
}
.mt-1 {
    margin: 0 !important;
}
.col-form-label {
    line-height: 1.2 !important;
}

.require {
    color: red;
}
.disabled {
    background-color: #e9ecef;
}

</style>
